import { render, staticRenderFns } from "./mailingAddress.vue?vue&type=template&id=2c159284&scoped=true&"
import script from "./mailingAddress.vue?vue&type=script&lang=js&"
export * from "./mailingAddress.vue?vue&type=script&lang=js&"
import style0 from "./mailingAddress.vue?vue&type=style&index=0&id=2c159284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c159284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c159284')) {
      api.createRecord('2c159284', component.options)
    } else {
      api.reload('2c159284', component.options)
    }
    module.hot.accept("./mailingAddress.vue?vue&type=template&id=2c159284&scoped=true&", function () {
      api.rerender('2c159284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/mailingAddress.vue"
export default component.exports